import { getService } from 'reducers/service';
import ServiceName from '../../shared/constants/serviceName';

export const createAddress = async (payload) => {
  const service = getService(ServiceName.CadHistoryEditAddress);
  const response = await service.create(payload);
  return response?.data || response;
};

export const searchPlaceAddresses = async (ptsPlaceID) => {
  const service = getService(ServiceName.CadSearchPlaceAddress);
  const response = await service.find({
    query: { ptsPlaceID, IsDeleted: false },
  });
  const rows = response?.data || response || [];
  return rows;
};

export const getAuthorityAddressById = async (ptsAddressID) => {
  const service = getService(ServiceName.CadSearchAddresses);
  return service.get(ptsAddressID);
};

export const getPlaceAddresses = async (ptsPlaceID) => {
  const service = getService(ServiceName.Places);
  const response = await service.get(ptsPlaceID);
  const placeAddresses = response?.PlaceAddress || [];

  return placeAddresses.map((placeAddress) => ({
    ...placeAddress.Address,
    ...placeAddress,
    City: placeAddress.Address?.City?.CityDescription || null,
  }));
};

export const createPlaceAddressLink = async (payload) => {
  const service = getService(ServiceName.CadSearchPlaceAddress);
  const response = await service.create(payload);
  return response?.data || response;
};

export const updatePlaceAddressLink = async (compositeKey, payload) => {
  const service = getService(ServiceName.CadSearchPlaceAddress);
  const response = await service.patch(null, payload, { query: compositeKey });
  return response?.data || response;
};

export const deletePlaceAddressLink = async (compositeKey) => {
  const service = getService(ServiceName.CadPlaceAddress);
  const response = await service.remove(compositeKey);
  return response?.data || response;
};

export const getPeopleAddresses = async (ptsPersonID) => {
  const service = getService(ServiceName.RecordPersonAddress);
  const response = await service.find({ query: { ptsPersonID } });
  const rows = response?.data || response || [];

  return rows.map((row) => {
    const address = Array.isArray(row.Address) && row.Address.length ? row.Address[0] : null;
    return {
      ...address,
      ptsPersonID: row.ptsPersonID,
      ptsAddressID: row.ptsAddressID,
      IsPrimary: row.IsPrimary,
      City: address?.City?.CityDescription || null,
      Created: row.Created,
      CreatedBy: row.CreatedBy,
      Updated: row.Updated,
      UpdatedBy: row.UpdatedBy,
    };
  });
};

export const createPersonAddressLink = async (payload) => {
  const service = getService(ServiceName.RecordPersonAddress);
  const response = await service.create(payload);
  return response?.data || response;
};

export const updatePersonAddressLink = async (compositeKey, payload) => {
  const service = getService(ServiceName.RecordPersonAddress);
  const response = await service.update(compositeKey, payload);
  return response?.data || response;
};

export const deletePersonAddressLink = async (compositeKey) => {
  const service = getService(ServiceName.RecordPersonAddress);
  const response = await service.remove(compositeKey);
  return response?.data || response;
};

export const getAddressDetails = async (ptsAddressID) => {
  const service = getService(ServiceName.ptsAddress);
  return service.get(ptsAddressID);
};

export const deleteAddressRecord = async (ptsAddressID) => {
  const service = getService(ServiceName.ptsAddress);
  return service.remove(ptsAddressID);
};

export const getAddressDuplicateCheckFields = async () => {
  const service = getService(ServiceName.Cdr);
  const response = await service.find({
    query: {
      CDRKey: 'AddDuplicate',
      ValueBoolean: true,
    },
  });
  return response?.data || response || [];
};

export const findAddressDuplicates = async (query) => {
  const service = getService(ServiceName.RmsAddressDuplicates);
  const response = await service.find({ query });
  return response?.data || response || [];
};

export const getAddressLookup = async (id) => {
  const service = getService(ServiceName.Address_lookup);
  const response = await service.get(id);
  return response || {};
};

export const getAddressCoordinateId = async (ptsAddressID) => {
  const service = getService(ServiceName.CadAddressPtsCoordinateID);
  const response = await service.get(ptsAddressID);
  return response?.ptsCoordinateID || null;
};

export const getAddressCoordinateDetails = async (ptsCoordinateID) => {
  const service = getService(ServiceName.CadAddressCoordinates);
  return service.get(ptsCoordinateID);
};

export const saveAddressCoordinates = async (payload) => {
  const service = getService(ServiceName.CadAddressCoordinates);
  return service.create(payload);
};

export const linkAddressCoordinate = async (ptsAddressID, ptsCoordinateID) => {
  const service = getService(ServiceName.CadAddressCoordinates);
  return service.patch(ptsAddressID, { ptsCoordinateID });
};

export const getAddressZones = async ({ ptsAddressID, ptsCoordinateID, coords }) => {
  const service = getService(ServiceName.Cad);
  const response = await service.get({
    type: 'address-zones',
    data: { ptsAddressID, ptsCoordinateID, coords },
  });
  return response || [];
};

export const createAddressZone = async (payload) => {
  const service = getService(ServiceName.PtsZoneInfo);
  return service.create(payload);
};

export const deleteAddressZone = async (ptsZoneInfoID) => {
  const service = getService(ServiceName.PtsZoneInfo);
  return service.remove(ptsZoneInfoID);
};

export const getAddressHistory = async (ptsAddressID) => {
  const service = getService(ServiceName.CadAddressHistory);
  const response = await service.find({ query: { ptsAddressID } });
  return response?.data || response || [];
};

export const getAddressParties = async (ptsAddressID) => {
  const service = getService(ServiceName.CadAddressParties);
  const response = await service.find({ query: { ptsAddressID } });
  return response?.data || response || [];
};

export const saveAddressParty = async (payload) => {
  const service = getService(ServiceName.CadAddressParties);
  return service.create(payload);
};

export const deleteAddressParty = async (ROWGUID) => {
  const service = getService(ServiceName.CadAddressParties);
  return service.remove(ROWGUID);
};

export const getAddressPrePlan = async (ptsAddressID) => {
  const service = getService(ServiceName.CadAddressPrePlan);
  return service.get(ptsAddressID);
};

export const saveAddressPrePlan = async (payload) => {
  const service = getService(ServiceName.CadAddressPrePlan);
  return service.create(payload);
};

export const getPrePlanInspections = async (ptsAddressID) => {
  const service = getService(ServiceName.CadAddressPrePlanInspections);
  const response = await service.get(ptsAddressID);
  return response || [];
};

export const savePrePlanInspection = async (payload) => {
  const service = getService(ServiceName.CadAddressPrePlanInspections);
  return service.create(payload);
};

export const deletePrePlanInspection = async (id) => {
  const service = getService(ServiceName.CadAddressPrePlanInspections);
  return service.remove(id);
};
